var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-inspector__properties c-inspect-properties"},_vm._l((_vm.activities),function(activity){return _c('plan-activity-view',{key:activity.id,attrs:{"activity":activity,"heading":_vm.heading}})}))}
var staticRenderFns = []

export { render, staticRenderFns }